export default __webpack_public_path__ + "7eb54907694387bf8f23ecbadc818abd.svg";